import { gql } from '@apollo/client'

export const galleryCollectionImageBulkWriteMutation = gql`
  mutation GalleryCollectionImageBulkWrite($data: [GalleryCollectionImageBulkWriteInput]!) {
    galleryCollectionImageBulkWrite(data: $data)
  }
`
